import { useEffect } from "react";
import { useLocation } from "react-router";
import { Route, Routes } from "react-router-dom";
import "./App.scss";
import AuthForm from "./components/Login & Signup/auth";
import About from "./pages/About";
import BlogsPage from "./pages/BlogsPage";
import Contactus from "./pages/Contact/Contactus";
import Home from "./pages/Home";
import Services from "./pages/Services";
import SingleBlog from "./pages/SingleBlog/SingleBlog";
import GscVerificationHead from "./components/GscVerification/GscVerificationHead";
import DentalCheckup from "./components/DentalCheckup/DentalCheckup";
import Layout from "./components/Layout";

function App() {
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };
  return (
    <>
      <GscVerificationHead />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog/:url" element={<SingleBlog />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/login" element={<AuthForm />} />
        <Route path="/dental-checkup" element={
          <Layout>
            <DentalCheckup />
          </Layout>
        } />
      </Routes>
    </>
  );
}

export default App;
